// extracted by mini-css-extract-plugin
export var logo = "_4o-2";
export var logoWrapper = "_4o-1";
export var strip = "_4o-0";